var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrescription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 5.333h2.666c.734 0 1.334.6 1.334 1.334V28c0 .733-.6 1.334-1.334 1.334H6.667c-.734 0-1.334-.6-1.334-1.334V6.667c0-.733.6-1.333 1.334-1.333h2.666",
    stroke: "url(#prescription_svg__mobile-paint0_linear)",
    strokeWidth: 1.6,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.333 6.667h-2.666V4c0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333v2.667z",
    stroke: "url(#prescription_svg__mobile-paint1_linear)",
    strokeWidth: 1.6,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.333h-8v1.334h8V5.334z",
    stroke: "url(#prescription_svg__mobile-paint2_linear)",
    strokeWidth: 1.6,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prescription_svg__mobile-paint0_linear",
    x1: 5.333,
    y1: 29.334,
    x2: 31.529,
    y2: 21.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prescription_svg__mobile-paint1_linear",
    x1: 14.666,
    y1: 6.667,
    x2: 18.066,
    y2: 5.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prescription_svg__mobile-paint2_linear",
    x1: 12,
    y1: 6.667,
    x2: 14.075,
    y2: 2.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })))));
}

export default SvgPrescription;